
export const fields = [
  {
    key: 'name',
    label: 'name',
    required: true, // this adds an entry to rules: [{ required: true, message: 'Username is required' }]
    placeholder: 'form.placeholderName',
  },
  {
    key: 'type',
    initialValue: 'TEMPLATE',
    onlyEdit: true,
    className: 'hidden-field',
  },
  {
    key: 'createdAt',
    label: 'createdAt',
    type: 'date',
    onlyView: true,
  },
  {

    key: 'description',
    label: 'description',
    widget: 'textarea',
    placeholder: 'form.placeholderDescription',
    widgetProps: {autoSize: {minRows: 5, maxRows: 12}},
    required: true,
    className: 'form-view-mode-vertical-item'
  },
];
